// extracted by mini-css-extract-plugin
export default {"wrapper":"AccordionBtnV2Sm_wrapper__gBtIp","accordion":"AccordionBtnV2Sm_accordion__0rEDJ","icon":"AccordionBtnV2Sm_icon__n2K+H","panel":"AccordionBtnV2Sm_panel__JLhob"};